module.exports = __webpack_public_path__ + "media/images/icons/facebook-w-5a291338517c62686ca27eae67a42ede.svg";